import { useState, useLayoutEffect } from 'react'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import { RootState } from 'dataStore/state'
import { useActions } from 'hooks/useActions'
import { IUser } from 'dto/users.dto'

/**
 * Текущий админ из JWT + списка users (для parentId / прав субадмина).
 */
export const useRole = () => {
  const { getAllUsers } = useActions()
  const { users } = useSelector((state: RootState) => state.users)

  const [decodedOldToken, setDecodedOldToken] = useState<any>()
  const [user, setUser] = useState<IUser | null>(null)

  const token = localStorage.getItem('token')
  if (token && !decodedOldToken) setDecodedOldToken(jwtDecode(token))

  useLayoutEffect(() => {
    if (!users || users.length === 0) getAllUsers()
    if (users.length > 0 && decodedOldToken && !user) {
      const currentUser = users?.find(
        userItem => userItem?.id === decodedOldToken?.id
      )
      if (currentUser) {
        setUser(currentUser)
      }
    }
  }, [users, decodedOldToken])

  const parentId = user?.parentId
  /** Субадмин = есть parentId (не суперадмин) */
  const isSubAdmin = typeof parentId === 'number' && parentId > 0

  return {
    parentId,
    userId: user?.id,
    user,
    isSubAdmin,
    isRoleReady: Boolean(user?.id),
  }
}
